import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const DashboardApi = {
    getMyStatistics: (options?: BaseApiQueryOptions) => apiQueryOptions(['getMyStatistics'], (api) => api.dashboard.getMyStatistics(), options),
    getContentSummary: (webinarId: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['getContentSummary', webinarId], (api) => api.dashboard.getContentSummary(webinarId), options)
};
